import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router';

const tags = {
	betaTag: require('@/assets/images/sub/ico_betatag.png')
};

const images = {
	dashboard1: require('@/assets/images/sub/img_function_bg_dashboard.png'),
	dashboard2: require('@/assets/images/sub/img_function_bg_dashboard2.png'),
	dashboard3: require('@/assets/images/sub/img_function_bg_dashboard3.png'),
	dashboard4: require('@/assets/images/sub/img_function_bg_dashboard4.png'),
	credit1: require('@/assets/images/sub/img_function_bg_credit.png'),
	credit2: require('@/assets/images/sub/img_function_bg_credit2.png'),
	pharosAI1: require('@/assets/images/sub/img_function_bg_pharosAI.png'),
	pharosAI2: require('@/assets/images/sub/img_function_bg_pharosAI2.png'),
	receiptocr1: require('@/assets/images/sub/img_function_bg_receiptocr.png'),
	receiptocr2: require('@/assets/images/sub/img_function_bg_receiptocr2.png'),
	receiptocr3: require('@/assets/images/sub/img_function_bg_receiptocr3.png'),
	mim: require('@/assets/images/sub/img_function_bg_mim.png')
};

const dashboardSlides = [
	{ src: images.dashboard1, alt: '대시보드 이미지' },
	{ src: images.dashboard2, alt: '대시보드 이미지' },
	{ src: images.dashboard3, alt: '대시보드 이미지' },
	{ src: images.dashboard4, alt: '대시보드 이미지' }
];
const creditSlides = [
	{ src: images.credit1, alt: '신용정보 이미지' },
	{ src: images.credit2, alt: '신용정보 이미지' }
];
const pharosAISlides = [
	{ src: images.pharosAI1, alt: '말만해 이미지' },
	{ src: images.pharosAI2, alt: '말만해 이미지' }
];
const receiptocrSlides = [
	{ src: images.receiptocr1, alt: '말만해 이미지' },
	{ src: images.receiptocr2, alt: '말만해 이미지' },
	{ src: images.receiptocr3, alt: '말만해 이미지' }
];

const ConvenienceContentListBox = () => {
	return (
		<ul>
			{/* 어카운팅 인사이트 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title new">Accounting Insights</strong>
							<p className="desc">
								최신 회계기준서 기반 <span className="font-bold">회계 기준 AI 챗봇</span>
								<br />
								현재 시행 중인 최신 기준서 기반의 <span className="font-bold">정확하고 신속한 답변</span> 제공
								<br />
								질문에 대한 답변과 근거 문단, 관련 문서를 실시간으로 제공
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">K-IFRS, K-GAAP, K-IFRS 18 등 주요 회계기준서 기반 답변 제공</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">삼일 회계법인 내·외부 문서를 바탕으로 근거 문단 및 관련 자료 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">최신 회계서 기준 반영 정확하고 신뢰도 높은 답변 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 말만해 AI */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">
								말만해 AI <img src={tags.betaTag} />
							</strong>
							<p className="desc">
								<span className="font-bold">업계 최초 LLM 기반 챗봇형 전표 자동 생성</span>
								<br />
								거래 입력부터 전표 생성까지 채팅으로 처리
								<br />
								반복적인 전표 입력 업무 자동화 및 정확도 향상
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">일상적인 문장 입력만으로 전표 자동 생성</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">거래 내용 분석을 통한 전표 정보 자동 구성</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">AI전표생성-내용확인-수정-저장만 하면 되는 놀라운 AI경험</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<Swiper
									modules={[Pagination]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{
										el: '.swiper-pagination',
										clickable: true
									}}
									observer={true}
									observeParents={true}>
									{pharosAISlides.map((slide, index) => (
										<SwiperSlide key={index}>
											<img src={slide.src} alt={slide.alt} />
										</SwiperSlide>
									))}
									<div className="swiper-pagination"></div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 영수증 업로드 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">
								영수증 업로드 <img src={tags.betaTag} />
							</strong>
							<p className="desc">
								<span className="font-bold">수기 입력이 필요했던 영수증 증빙 처리</span>
								<br />
								영수증 이미지 업로드로 거래 정보 자동 인식
								<br />
								수집 불가 증빙의 전표 처리 업무 간소화
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">영수증 이미지 업로드만으로 거래 정보 자동 인식</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">영수증 내용 기반 전표 정보 자동 생성</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">검수 후 전표 연동까지 간편 처리</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<Swiper
									modules={[Pagination]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{
										el: '.swiper-pagination',
										clickable: true
									}}
									observer={true}
									observeParents={true}>
									{receiptocrSlides.map((slide, index) => (
										<SwiperSlide key={index}>
											<img src={slide.src} alt={slide.alt} />
										</SwiperSlide>
									))}
									<div className="swiper-pagination"></div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 즐겨찾기 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">즐겨찾기</strong>
							<p className="desc">
								<span className="font-bold">자주 사용하는 기능</span>만 모아모아 <br />
								최대 25개까지 <span className="font-bold">즐겨찾기에서 관리</span>할 수 있어요.
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">자주 사용하는 기능만 직접 선택하여 관리</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">선택한 기능의 자유로운 순서변경</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">비활성화, 활성화 버튼을 통해 개인화 지원</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 대시보드 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">대시보드</strong>
							<p className="desc">
								<span className="font-bold">시각 데이터</span>로 손익과 매출 현황, 계좌/카드내역 등 <br />
								<span className="font-bold">기업의 경영상황 파악 및 인사이트 제공</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										매출/매입현황 및 매출이익, 외상매출 및 매입, 증빙별 매출매입현황 매일매일 확인
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">계좌 잔액 및 입출금현황, 전월대비 입/출금 현황 한 눈에 파악</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">카드 사용현황 및 월 누적/청구 금액, 월별추이 등 금융 현황 쉽게 파악</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<Swiper
									modules={[Pagination]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{
										el: '.swiper-pagination',
										clickable: true
									}}
									observer={true}
									observeParents={true}>
									{dashboardSlides.map((slide, index) => (
										<SwiperSlide key={index}>
											<img src={slide.src} alt={slide.alt} />
										</SwiperSlide>
									))}
									<div className="swiper-pagination"></div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 신용정보 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">신용정보</strong>
							<p className="desc">
								<span className="font-bold">업계 최초</span> 자사의 신용등급 관리와 함께
								<br />
								<span className="font-bold">거래 업체의 신용정보 확인 및 거래위험 파악</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">NICE평가정보가 보유한 국내 기업 신용평가 정보 제공 및 연동</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">거래처 신용등급 및 개요, 재무/비재무 정보 등 각종 평가데이터 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">자사 및 거래처 신용정보의 체계적 관리 및 경영활동에 활용</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<Swiper
									modules={[Pagination]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{
										el: '.swiper-pagination',
										clickable: true
									}}
									observer={true}
									observeParents={true}>
									{creditSlides.map((slide, index) => (
										<SwiperSlide key={index}>
											<img src={slide.src} alt={slide.alt} />
										</SwiperSlide>
									))}
									<div className="swiper-pagination"></div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 프로젝트 관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">프로젝트 관리</strong>
							<p className="desc">
								프로젝트/현장정보 관리 기능을 통해
								<br />
								<span className="font-bold">프로젝트별 비용관리 및 수익분석을 효과적으로 수행</span>하도록 지원
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">각 프로젝트 진행 중 발생하는 다양한 비용을 추적하여 체계적인 관리 가능</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">프로젝트 또는 현장별 거래 입력을 통한 총 매출액 및 비용 산출 가능</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">프로젝트별, 현장별, 부서별 손익보고서를 제공하여 수익 분석에 활용</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 기업뱅킹 연동 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">기업뱅킹 연동</strong>
							<p className="desc">
								<span className="font-bold">금융사들과 직접 연동</span>하여
								<br />
								스텔라에서 <span className="font-bold">더 빠르고 정확한 이체</span>서비스를 이용
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										금융사 기업뱅킹 오픈API 연동으로 은행 사이트 접속 필요없이 바로 이체 가능
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">
										농협은행, 국민은행, 신한은행 등 주요 금융사 API 연동 확대를 통한 대고객 편의성 제공
									</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">일반이체 및 대금/급여이체 시 더욱 자유로운 이체건수 및 혜택 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 원천세 신고 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">원천세 신고</strong>
							<p className="desc">
								<span className="font-bold">원천세 신고서는 물론 지급명세서까지</span>
								<br />
								홈택스 검증 기능을 통해 누락없이 <span className="font-bold">완벽한 신고서로 자동생성</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										원천징수 이행상황 신고서 메뉴에서 해당기간 급여데이터로 자동집계되어 신고서 작성
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">최종 신고서 제출 전 오류확인을 위한 홈택스 접속없이 홈택스 교차검증 지원</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">홈택스 납부서 조회, 접수증 및 납부서 다운로드 및 출력 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 부가세 신고 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">부가세 신고</strong>
							<p className="desc">
								사업자라면 필수인 부가세 신고,
								<br />
								<span className="font-bold">회계전표를 바탕으로 신고에 필요한 각종 신고서 자동으로 생성</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">최신 세무 매입 매출 전표 증빙 유형 · 계정 과목 기반 신고서 자동생성</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">최종 신고서 제출 전 오류확인을 위한 홈택스 접속없이 홈택스 교차검증 지원</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										생성된 신고서는 전자파일로 변환하여 자료 다운로드 후 직접 홈택스 신고 가능
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 세금 계산서 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">세금 계산서</strong>
							<p className="desc">
								매입매출전표 등록 및 수정 시
								<br />
								<span className="font-bold">거래명세서, 세금계산서 버튼 클릭만으로 동시 발행 가능</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										홈택스 접속할 필요없이 세금계산서 자동생성 및 수정세금계산서까지 발급 가능
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">거래명세서 발행 시 여러 건의 전표를 선택하여 집계발행 및 일괄발행</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">이메일로 자동 발행되며 발행 내역의 출력 가능</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 모바일 재고관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">모바일 재고관리</strong>
							<p className="desc">
								ERP 연동, 스캔 기반 입·출고, 재고조정까지
								<br />
								<span className="font-bold">모바일에서 빠르고 정확하게 재고 관리</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										ERP와 연동된 재고 정보를 모바일에서 조회하고 품목·창고별 재고현황을 실시간으로 확인
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">
										바코드·QR코드 스캔으로 제품등록, 입고·출고를 빠르게 처리 외부 현장에서도 즉시 반영 가능
									</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										창고별 재고량을 확인하고 다른 창고로 재고를 이동하는 업무를 모바일에서 처리
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<img src={images.mim} alt="mim" />
							</div>
							<div className="content-image qr">
								<div className="btn-group">
									<Link
										to="https://apps.apple.com/kr/app/id6754354290"
										className="btn_apple"
										target="_blank"
										title="모바일재고관리 앱 app store 새창열기"></Link>
									<Link
										to="https://play.google.com/store/apps/details?id=com.finger.pharosapp"
										className="btn_google"
										target="_blank"
										title="모바일 재고관리 앱 google store 새창열기"></Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 보고서 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">보고서</strong>
							<p className="desc">
								수기 작성이 필요 없는 <br />
								<span className="font-bold">경영보고서·금융보고서·급여보고서·월간결산보고서 자동 생성</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										미수/미지급 보고서 및 기간별 손익보고서 등 경영 보고서 자동생성 및 다운로드 제공
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">자금일보 및 월간 자금 흐름·재무 현황 시각화 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										사원별/월별/연간 급여현황, 지급 항목별/공제항목별 집계 및 급여 보고서 조회와 출력 제공
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 기간비용 & 기간수익 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">기간비용 & 기간수익</strong>
							<p className="desc">
								<span className="font-bold">기간에 걸쳐있는</span> 비용과 수익을 <br />
								정확하게 관리
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">보험료, 임대료, 구축사업 등 다양한 업무 시나리오 적용 가능</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">기간과 금액에 맞춰 자동으로 상각표 생성</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">월별 인식이 필요한 금액만큼 대체전표 발행</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 반제관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">반제관리</strong>
							<p className="desc">
								매출채권(AR)∙매입채무(AP) 관리가
								<br />더 똑똑해집니다.
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">통장 입출금 내역과 연계해 반제전표 생성</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">전액반제, 부분반제, 초과반제 등 유연한 업무처리 가능</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">채권연령표를 통해 체계적인 자금계획 수립 가능</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 세무대리인 소통함 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">세무대리인 소통함</strong>
							<p className="desc">
								이제 세무대리인과
								<br />더 쉽고 빠르게 소통하세요.
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">실시간 문의 및 답변 관리 가능</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">댓글 기능을 통한 히스토리 관리</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">파일 공유 기능을 통한 자료관리</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default ConvenienceContentListBox;
